import { EnvironmentOptions, Transport } from '../types';
import { createDebugTransport } from './debug-transport';
import { createRudderTransport } from './rudder-transport';
import { createBufferTransport } from './buffer-transport';
import { Transports, createTransportContainer } from './transport-container';
import configuration from '../config';
import { createGoogleTagManagerTransport } from './gtm-transport';

export const getTransports = (config: EnvironmentOptions, platformConfigurations = configuration): Transports => {
  const application = platformConfigurations[config.platform];

  const transports: Transports = {};

  if (config.environment !== 'local') {
    const environmentKey = config.environment === 'production' ? 'productionKey' : 'acceptanceKey';

    const rudderKey = application.rudder?.[environmentKey];
    if (rudderKey) {
      const rudderTransportPromise = createRudderTransport(rudderKey, config.opCo, config.platform);
      transports.rudder = createBufferTransport(rudderTransportPromise, {
        startImmediately: application.rudder?.startImmediately,
      });
    }
  }

  if (application?.gtm?.enabled) {
    const gtmTransportPromise = createGoogleTagManagerTransport(config.opCo, config.platform);
    transports.gtm = createBufferTransport(gtmTransportPromise, { startImmediately: application.gtm?.startImmediately });
  }

  transports.debug = createDebugTransport();

  return transports;
};

const initTransports = (config: EnvironmentOptions, platformConfigurations = configuration): Transport => {
  const transports = getTransports(config, platformConfigurations);
  return createTransportContainer(transports);
};

export default initTransports;
